import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChartCandels = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 3C8.41421 3 8.75 3.33579 8.75 3.75V6.25H10C10.5523 6.25 11 6.69772 11 7.25V17.25C11 17.8023 10.5523 18.25 10 18.25H8.75V20.25C8.75 20.6642 8.41421 21 8 21C7.58579 21 7.25 20.6642 7.25 20.25V18.25H6C5.44772 18.25 5 17.8023 5 17.25V7.25C5 6.69772 5.44772 6.25 6 6.25H7.25V3.75C7.25 3.33579 7.58579 3 8 3ZM6.5 7.75V16.75H9.5V7.75H6.5ZM16 5.5C16.4142 5.5 16.75 5.83579 16.75 6.25V8.25H18C18.5523 8.25 19 8.69772 19 9.25V15.25C19 15.8023 18.5523 16.25 18 16.25H16.75V18.25C16.75 18.6642 16.4142 19 16 19C15.5858 19 15.25 18.6642 15.25 18.25V16.25H14C13.4477 16.25 13 15.8023 13 15.25V9.25C13 8.69772 13.4477 8.25 14 8.25H15.25V6.25C15.25 5.83579 15.5858 5.5 16 5.5ZM14.5 14.75V9.75H17.5V14.75H14.5Z"
        />
      </svg>
    );
  }
);
